/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_TitleInputs */

const en_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style Guide Manager`)
};

const fr_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestionnaire de guide de style`)
};

const de_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Styleguide-Manager`)
};

const it_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Responsabile della guida di stile`)
};

const ru_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Менеджер руководства по стилю`)
};

const es_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Administrador de guías de estilo`)
};

const zh_cn2_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`样式指南管理器`)
};

const ja_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイルガイドマネージャー`)
};

const hi_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्टाइल गाइड प्रबंधक`)
};

const pt_pt2_style_guide_manager_title = /** @type {(inputs: Style_Guide_Manager_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerente de Guia de Estilo`)
};

/**
* | output |
* | --- |
* | "Style Guide Manager" |
*
* @param {Style_Guide_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_title = /** @type {((inputs?: Style_Guide_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_title(inputs)
	if (locale === "de") return de_style_guide_manager_title(inputs)
	if (locale === "it") return it_style_guide_manager_title(inputs)
	if (locale === "ru") return ru_style_guide_manager_title(inputs)
	if (locale === "es") return es_style_guide_manager_title(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_title(inputs)
	if (locale === "ja") return ja_style_guide_manager_title(inputs)
	if (locale === "hi") return hi_style_guide_manager_title(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_title(inputs)
	return en_style_guide_manager_title(inputs)
});